import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { FinanceComponent } from './modules/finance/finance.component';
import { LoginComponent } from './shared/authentication/login/login.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';
import { MyDashboardComponent } from './modules/my-dashboard/my-dashboard.component';
import { SubmitRequestComponent } from './modules/common/components/submit-request/submit-request.component';
import { RequestDetailsComponent } from './modules/common/components/request-details/request-details.component';
import { ApprovalsHistoryComponent } from './modules/common/components/approvals-history/approvals-history.component';

const routes: Routes = [
  {
    path: "support",
    loadChildren: () =>
      import("./modules/admin/admin.module").then((m) => m.AdminModule),
  },
  {
    path: "identity",
    loadChildren: () =>
      import("./modules/identity/identity.module").then((m) => m.IdentityModule),
  },
  {
    path: "association",
    loadChildren: () =>
      import("./modules/association/association.module").then((m) => m.AssociationModule),
  },
  {
    path: "workflow",
    loadChildren: () =>
      import("./modules/workFlow/workflow.module").then((m) => m.WorkflowModule),
  },
  { path: 'login', component: LoginComponent },
  { path: '401', component: UnauthorizedComponent },
  { path: '404', component: NotFoundComponent },
  { path: 'finance', component: FinanceComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'my-dashboard', component: MyDashboardComponent },
  { path: 'common/submit-request', component: SubmitRequestComponent },
  { path: 'common/submit-request/:id', component: SubmitRequestComponent },
  { path: 'common/request-details/:id', component: RequestDetailsComponent },
  { path: 'common/approvals-history', component: ApprovalsHistoryComponent },
  {path: '', component: DashboardComponent},
  { path: '**', component: NotFoundComponent}

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
